import { render, staticRenderFns } from "./TraceabilityEventsStepper.vue?vue&type=template&id=3b067b53&scoped=true"
import script from "./TraceabilityEventsStepper.vue?vue&type=script&lang=js"
export * from "./TraceabilityEventsStepper.vue?vue&type=script&lang=js"
import style0 from "./TraceabilityEventsStepper.vue?vue&type=style&index=0&id=3b067b53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b067b53",
  null
  
)

export default component.exports